import _ from 'lodash';
import { ObjectType } from 'api/pushes';
import {
  FieldDataType,
  FieldOption,
  FieldTypes,
} from 'components/organisms/module-settings/fields/types';
import { AutomationOperations } from 'components/organisms/tasks/filters/operations';

export enum AutomationTriggerIdentifier {
  CronTrigger = 'CRON_TRIGGER',
  AnyTaskDueDateIsAdded = 'ANY_TASK_DUE_DATE_IS_ADDED',
  AnyTaskDueDateIsRemoved = 'ANY_TASK_DUE_DATE_IS_REMOVED',
  AnyTaskDueDateIsPostponed = 'ANY_TASK_DUE_DATE_IS_POSTPONED',
  AnyTaskDueDateIsPreponed = 'ANY_TASK_DUE_DATE_IS_PREPONED',
  AnyTaskAssigneeIsAdded = 'ANY_TASK_ASSIGNEE_IS_ADDED',
  AnyTaskAssigneeIsRemoved = 'ANY_TASK_ASSIGNEE_IS_REMOVED',
  AnyTaskAssigneeIsCleared = 'ANY_TASK_ASSIGNEE_IS_CLEARED',
  AnyTaskDueDateOverdue = 'ANY_TASK_DUE_DATE_OVERDUE',
  NewMessageInTaskByUserType = 'NEW_MESSAGE_IN_TASK_BY_USER_TYPE',
  /**
   * @deprecated
   */
  TaskCreated = 'TASK_CREATED',
  TaskCreatedV2 = 'TASK_CREATED_V2',
  TaskDeleted = 'TASK_DELETED',
  TaskDueDateIsUpdated = 'TASK_DUE_DATE_IS_UPDATED',
  /**
   * @deprecated
   */
  TaskStatusIsUpdated = 'ANY_TASK_STATUS_IS_UPDATED',
  TaskStatusIsUpdatedV2 = 'TASK_STATUS_IS_UPDATED_V2',
  /**
   * @deprecated
   */
  TaskAnyFieldIsUpdated = 'ANY_TASK_FIELD_IS_UPDATED',
  TaskAnyFieldIsUpdatedV2 = 'TASK_ANY_FIELD_IS_UPDATED_V2',
  TaskApprovalStatusIsUpdated = 'TASK_APPROVAL_STATUS_IS_UPDATED',
  TaskCSATSubmitted = 'TASK_CSAT_SUBMITTED',
  TaskBecomesOverdue = 'TASK_BECOMES_OVERDUE',
  TaskRemainsInCertainStatus = 'TASK_REMIANS_IN_CERTAIN_STATUS',
  NewMessageInTask = 'NEW_MESSAGE_IN_TASK',
  TaskAssigneeIsUpdated = 'TASK_ASSIGNEE_IS_UPDATED',
  TaskDateReachingInXDays = 'TASK_DATE_REACHING_IN_X_DAYS',
  TaskDateCrossedXDays = 'TASK_DATE_CROSSED_X_DAYS',
  TaskDueDateReachingInXDays = 'TASK_DUE_DATE_REACHING_IN_X_DAYS',
  TaskDueDateCrossedXDays = 'TASK_DUE_DATE_CROSSED_X_DAYS',
  /**
   * @deprecated
   */
  PhaseCreated = 'PHASE_CREATED',
  PhaseCreatedV2 = 'PHASE_CREATED_V2',
  /**
   * @deprecated
   */
  PhaseStartDateIsChanged = 'ANY_PHASE_START_DATE_IS_CHANGED',
  PhaseStartDateIsChangedV2 = 'PHASE_START_DATE_IS_CHANGED_V2',
  /**
   * @deprecated
   */
  PhaseDueDateIsChanged = 'ANY_PHASE_DUE_DATE_IS_CHANGED',
  PhaseDueDateIsChangedV2 = 'PHASE_DUE_DATE_IS_CHANGED_V2',
  /**
   * @deprecated
   */
  PhaseStatusIsChanged = 'ANY_PHASE_STATUS_IS_CHANGED',
  PhaseStatusIsChangedV2 = 'PHASE_STATUS_IS_CHANGED_V2',
  /**
   * @deprecated
   */
  PhaseNameIsChanged = 'PHASE_NAME_IS_CHANGED',
  PhaseNameIsChangedV2 = 'PHASE_NAME_IS_CHANGED_V2',
  PhaseDeleted = 'PHASE_DELETED',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  BiWeekly = 'BI_WEEKLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  HalfYearly = 'HALF_YEARLY',
  ANNUALLY = 'ANNUALLY',
  DateFieldTrigger = 'DATE_FIELD_TRIGGER',
  FormDueDateIsUpdated = 'FORM_DUE_DATE_IS_UPDATED',
  FormStatusIsUpdated = 'FORM_STATUS_IS_UPDATED',
  FormAssigneeIsUpdated = 'FORM_ASSIGNEE_IS_UPDATED',
  FormAnyFieldIsUpdated = 'FORM_ANY_FIELD_IS_UPDATED',
  FormResponseSubmitted = 'FORM_RESPONSE_SUBMITTED',
  NewMessageInForm = 'NEW_MESSAGE_IN_FORM',
  FormDeleted = 'FORM_DELETED',
  FormApprovalStatusIsUpdated = 'FORM_APPROVAL_STATUS_IS_UPDATED',
  FormCSATSubmitted = 'FORM_CSAT_SUBMITTED',
  ProjectCreated = 'PROJECT_CREATED',
  ProjectAnyFieldIsUpdated = 'PROJECT_ANY_FIELD_IS_UPDATED',
  ProjectArchived = 'PROJECT_ARCHIVED',
  ProjectDeleted = 'PROJECT_DELETED',
  CustomerInvitedToProject = 'CUSTOMER_INVITED_TO_PROJECT',
  ProjectPlaceholderResolved = 'PROJECT_PLACEHOLDER_RESOLVED',
}

export enum AutomationActionIdentifier {
  SendEmail = 'SEND_EMAIL',
  Sleep = 'SLEEP',
  StoreKeyEventValue = 'STORE_KEY_EVENT_VALUE',
  CreateTaskMessage = 'CREATE_TASK_MESSAGE',
  UpdateTaskStartDate = 'UPDATE_TASK_START_DATE',
  UpdateTaskDueDate = 'UPDATE_TASK_DUE_DATE',
  UpdateTaskField = 'UPDATE_TASK_FIELD',
  RequestTaskApproval = 'REQUEST_TASK_APPROVAL',
  NotifySomeone = 'NOTIFY_SOMEONE',
  InviteSomeone = 'INVITE_SOMEONE',
  SendForm = 'SEND_FORM',
  WebRequest = 'WEB_REQUEST',
  UpdateTaskStatus = 'UPDATE_TASK_STATUS',
  UpdateTaskPhase = 'UPDATE_TASK_PHASE',
  UpdateProjectFields = 'UPDATE_PROJECT_FIELDS',
  ShiftProjectDates = 'SHIFT_PROJECT_DATES',
  CreateTask = 'CREATE_TASK',
  CreateSubTask = 'CREATE_SUB_TASK',
  UpdateTaskAssignee = 'UPDATE_TASK_ASSIGNEE',
  ShiftTaskDates = 'SHIFT_TASK_DATES',
  DeleteTask = 'DELETE_TASK',
  CreateDocument = 'CREATE_DOCUMENT',
  SendProjectUpdates = 'SEND_PROJECT_UPDATES',
  ImportTemplate = 'IMPORT_TEMPLATE',
  CreateProjectMessage = 'CREATE_PROJECT_MESSAGE',
  UpdateResourceAllocation = 'UPDATE_RESOURCE_ALLOCATION',
  UpdateProjectStatus = 'UPDATE_PROJECT_STATUS',
  ArchiveProject = 'ARCHIVE_PROJECT',
  DeleteProject = 'DELETE_PROJECT',
  UpdatePhaseStartDate = 'UPDATE_PHASE_START_DATE',
  UpdatePhaseDueDate = 'UPDATE_PHASE_DUE_DATE',
  UpdatePhaseStatus = 'UPDATE_PHASE_STATUS',
  DeletePhase = 'DELETE_PHASE',
  NotifyViaSlack = 'NOTIFY_VIA_SLACK',
  InviteTeamMember = 'INVITE_TEAM_MEMBER',
  SendWebRequest = 'SEND_WEB_REQUEST',
  ExitAutomation = 'EXIT_AUTOMATION',
  FollowTask = 'FOLLOW_TASK',
}

export enum AutomationSource {
  ProjectTemplate = 'PROJECT_TEMPLATE',
  ProjectPhaseTemplate = 'PROJECT_PHASE_TEMPLATE',
  TaskTemplate = 'TASK_TEMPLATE',
  None = 'NONE',
  GLOBAL = 'GLOBAL',
  FormTemplate = 'FORM_TEMPLATE',
  GlobalProject = 'GLOBAL_PROJECT',
  GlobalProjectPhase = 'GLOBAL_PROJECT_PHASE',
  GlobalTask = 'GLOBAL_TASK',
  GlobalForm = 'GLOBAL_FORM',
}

export const GLOBAL_AUTOMATIONS = [
  AutomationSource.GlobalProject,
  AutomationSource.GlobalTask,
  AutomationSource.GlobalProjectPhase,
  AutomationSource.GlobalForm,
  AutomationSource.None,
];

export enum AutomationInputFieldType {
  TASK = 'TASK',
  PROJECT = 'PROJECT',
  ProjectPhase = 'PROJECT_PHASE',
  TaskFieldsSelector = 'TASK_FIELDS_SELECTOR',
  ProjectFieldsSelector = 'PROJECT_FIELDS_SELECTOR',
}

export enum AutomationFieldRenderType {
  Cron = 'CRON',
  SingleSelect = 'SINGLE_SELECT',
  MultiSelect = 'MULTI_SELECT',
  SimpleSearchFilter = 'SIMPLE_SEARCH_FILTER',
  RichText = 'RICH_TEXT',
  MultiSelectPopup = 'MULTI_SELECT_POPUP',
  LabelBold = 'LABEL_BOLD',
  Default = '_DEFAULT_',
  KeyValuePair = 'KEY_VALUE_PAIR',
  Toggle = 'TOGGLE',
  Radio = 'RADIO',
  Email = 'EMAIL',
  EmailInput = 'EMAIL_INPUT',
  Squad = 'SQUAD',
  AllProjectMembers = 'ALL_PROJECT_MEMBERS',
  Iso8601PeriodField = 'ISO_8601_PERIOD_FIELD',
  FormQuestion = 'FORM_QUESTION',
  DaysSelectorInput = 'DAYS_SELECTOR_INPUT',
  MessageSenderType = 'MESSAGE_SENDER_TYPE',
  /**
   * @deprecated
   */
  ComposeEmail = 'COMPOSE_EMAIL',
  TemplatePicker = 'TEMPLATE_PICKER',
  ObjectSelector = 'OBJECT_SELECTOR',
  MultipleObjectsSelector = 'OBJECTS_SELECTOR',
  EmailCompose = 'EMAIL_COMPOSE',
  Effort = 'EFFORT_FIELD',
  ConnectToSlack = 'CONNECT_TO_SLACK',
  JsonEditor = 'JSON_EDITOR',
}

export type AutomationTriggerFieldOption = FieldOption & {
  label: string;
  valueStr?: string;
};

export type AutomationField = {
  sourceType: ObjectType;
  fieldId: number;
  fieldName: string;
  fieldNameSanitized?: string;
  fieldType: FieldTypes;
  fieldDataType: FieldDataType;
  customField: boolean;
  parentFieldName: string;
  objectType: ObjectType;
  fieldGroup: string;
  fieldColumnName: string;
  fieldLabel: string;
  private: false;
  isEditable: boolean;
  required?: boolean;
  automationInputFieldType?: AutomationInputFieldType;
  sticky?: boolean;
  dynamic?: boolean;
  triggersDynamic?: boolean;
  placeholderValue: string;
  placeholderLabel: string;
  renderAs?: AutomationFieldRenderType;
  hint?: string;
  metaData?: {
    optionsAvailable?: boolean;
    options: AutomationTriggerFieldOption[];
    range?: {
      min: number;
      max: number;
    };
    rangeAvailable?: boolean;
    /**
     * This is just a FE property
     */
    allowRelativeDateOps?: boolean;
    /**
     * This is just a FE property
     */
    allowAbsDateOps?: boolean;
  };
  allowedTriggerConditionOperations?: AutomationOperations[];
};

export type AutomationFieldOption = Omit<FieldOption, 'value'> & {
  automationValueMeta?: string | number | Record<string, unknown>;
  value?: number | string;
};

export type AutomationActionInputField = Omit<AutomationField, 'metaData'> & {
  required?: boolean;
  hidden?: boolean;
  hint?: string;
  fieldValue?: unknown;
  isValueMeta?: boolean;
  fieldSectionLabel?: string;
  inputJsonPath?: string;
  metaFieldValue?: unknown;
  childFields?: AutomationActionInputField[];
  metaData: Omit<AutomationField['metaData'], 'options'> & {
    options?: AutomationFieldOption[];
  };
  renderParams?: AutomationFieldRenderParams[];
  dynamicFriendlyVariableFields?: boolean;
};

export const isValueMetaStringOrNumber = (
  m: string | number | Record<string, unknown> | undefined,
): m is string | number => _.isString(m) || _.isNumber(m);

export enum AutomationFieldRenderParams {
  ShowUsers = 'SHOW_USERS',
  ShowTeams = 'SHOW_TEAMS',
  ShowProjectOwner = 'SHOW_PROJECT_OWNER',
  ShowAllProjectMembers = 'SHOW_ALL_PROJECT_MEMBERS',
  HorizontalRadio = 'HORIZONTAL_RADIO',
  VerticalRadio = 'VERTICAL_RADIO',
  Bold = 'BOLD',
  SimpleVariable = 'SIMPLE_VARIABLE',
  ConditionalVariable = 'CONDITIONAL_VARIABLE',
  Emojis = 'EMOJIS',
  Checkbox = 'CHECKBOX',
  Images = 'IMAGES',
  ShowDays = 'SHOW_DAYS',
  ShowWeeks = 'SHOW_WEEKS',
  ShowMonths = 'SHOW_MONTHS',
  LimitText = 'LIMIT_TEXT',
  AllowSmartFills = 'ALLOW_SMART_FILLS',
}
